export default __webpack_public_path__ + "static/media/640_store03-it-web.27fcff75.png";